module.exports = __webpack_public_path__ + "img/sample_creative_07@1.5x.2b130b5c.jpg";